import { Component, EventEmitter, OnInit, Output, ViewChild, Input } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { AnoSafraService } from 'src/app/services/ano-safra.service';
import { FazendaService } from 'src/app/services/fazenda.service';
import { CulturaService } from 'src/app/services/cultura.service';
import { AnoSafra } from 'src/app/classes/AnoSafra';
import { Fazenda } from 'src/app/classes/Fazenda';
import { Cultura } from 'src/app/classes/Cultura';
import { ItensSolicitacaoComprasDTO, SolicitacaoComprasDTO, SolicitacaoComprasInputDto } from 'src/app/classes/SolicitacaoComprasDto';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';
import { SolicitacaoCompraService } from 'src/app/services/solicitacao-compra.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { PlanejamentoFiltroDto } from 'src/app/classes/PlanejamentoFiltroDto';
import { finalize } from 'rxjs/operators';
import { GrupoProdutoService } from 'src/app/services/grupo-produto.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { GrupoProduto } from 'src/app/classes/GrupoProduto';
import { Produto } from 'src/app/classes/Produto';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-forms-solicitacao-compra',
  templateUrl: './forms-solicitacao-compra.component.html',
  styleUrls: ['./forms-solicitacao-compra.component.scss']
})
export class FormsSolicitacaoCompraComponent implements OnInit {
  @ViewChild('Modal', { static: false }) modal: UiModalComponent;
  @Output() finalizarSave: EventEmitter<any> = new EventEmitter();
  @Input() isPlanejada: boolean = true;

  solicitacaoModel: SolicitacaoComprasInputDto = new SolicitacaoComprasInputDto();
  solicitacaoId: number = 0;
  isSubmit: boolean = false;
  carregando: boolean = false;
  
  step: number = 1;
  groupedItems: any[] = [];

  anosSafras: AnoSafra[] = [];
  fazendas: Fazenda[] = [];
  culturas: Cultura[] = [];
  listPlanejamentos: any[] = [];

  gruposProdutos: GrupoProduto[] = [];
  produtosPaginados: Produto[] = [];
  inputProduto$ = new Subject<string | null>();
  carregandoProduto: boolean = false;
  pagina: number = 1;
  termoBusca: string = '';
  ultimaPagina: boolean = false;
  currentGrupoId: number = 0;
  areaTotalPlanejada: number = 0;

  constructor(
    private storageService: StorageService,
    private utils: UtilsService,
    private anoSafraService: AnoSafraService,
    private fazendaService: FazendaService,
    private culturaService: CulturaService,
    private solicitacaoService: SolicitacaoCompraService,
    private planejamentoService: PlanejamentoService,
    private grupoProdutoService: GrupoProdutoService,
    private produtoService: ProdutoService
  ) { 
    this.inputProduto$.subscribe((newTerm) => {
      this.pagina = 1;
      this.fetchMoreProdutos(newTerm, this.currentGrupoId);
    });
  }

  ngOnInit() {
    this.carregarDadosIniciais();
  }

  abrirModal(solicitacao: SolicitacaoComprasDTO = null, step: number = 1): void {
    this.isSubmit = false;
    this.step = step;
    this.groupedItems = [];
    if (solicitacao != null) {
      console.debug(solicitacao)
      this.solicitacaoId = solicitacao.Id;
      this.solicitacaoModel = new SolicitacaoComprasInputDto();
      this.solicitacaoModel.Descricao = solicitacao.Descricao;
      this.solicitacaoModel.AnoSafraId = solicitacao.AnoSafraId;
      
      // Use robust parsing to handle array strings (even single IDs) in the Ids properties
      this.solicitacaoModel.FazendaIds = this.parseIds(solicitacao.FazendasIds);
      this.solicitacaoModel.CulturaIds = this.parseIds(solicitacao.CulturasIds);
      this.solicitacaoModel.PlanejamentoIds  = this.parseIds(solicitacao.PlanejamentoIds);

      // Always map items during edit to prevent loss when saving from Step 1
      if (solicitacao.ItensSolicitacaos) {
        // Clone items to avoid modifying the original reference until saved
        this.solicitacaoModel.Itens = solicitacao.ItensSolicitacaos.map(item => {
          const newItem = new ItensSolicitacaoComprasDTO();
          Object.assign(newItem, item);
          // Ensure dates are Date objects
          if (item.DataMinimoEntrega) newItem.DataMinimoEntrega = new Date(item.DataMinimoEntrega);
          if (item.DataMaximoEntrega) newItem.DataMaximoEntrega = new Date(item.DataMaximoEntrega);
          return newItem;
        });

        if (this.step === 2) {
          this.agruparItens(this.solicitacaoModel.Itens);
        }
      }
      
      if (!this.isPlanejada) {
        this.carregarTalhoes();
        // Load existing products to ensure labels are shown in ng-select
        this.carregarProdutosExistentes();
      }
    } else {
      this.solicitacaoId = 0;
      this.solicitacaoModel = new SolicitacaoComprasInputDto();
      this.listPlanejamentos = [];
    }
    console.debug('Itens', this.solicitacaoModel.Itens)
    this.modal.show();
  }

  salvarPasso1(form: NgForm): void {
    this.isSubmit = true;
    if (form.valid) {
      this.save();
    }
  }

  fecharModal(): void {
    this.modal.hide();
    this.isSubmit = false;
  }

  carregarDadosIniciais() {
    const fazenda = this.storageService.getFazenda();
    
    this.anoSafraService.getAnosSafrasPorFazenda(fazenda.Id).subscribe(ret => {
      this.anosSafras = ret;
    });

    this.fazendaService.getFazendas().subscribe(res => this.fazendas = res);
    this.culturaService.getCulturas().subscribe(res => this.culturas = res);
    this.grupoProdutoService.getGruposProduto().subscribe(res => this.gruposProdutos = res);
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    );
  }

  continuar(form: NgForm): void {
    if (!form.valid) {
      this.isSubmit = true;
      this.utils.handleWarning('Por favor, preencha todos os campos obrigatórios corretamente antes de continuar.');
      return;
    }

    this.solicitacaoModel.AnoSafraIds = [this.solicitacaoModel.AnoSafraId];
    this.solicitacaoModel.IsPlanejada = this.isPlanejada;

    if (!this.isPlanejada) {
      this.carregando = true;
      this.planejamentoService.buscarAreaPlantada(this.solicitacaoModel.PlanejamentoIds).pipe(finalize(() => this.carregando = false)).subscribe({
        next: (res) => {
          this.areaTotalPlanejada = res || 0;
          this.carregarProdutosExistentes();
          this.step = 2;
        },
        error: (err) => this.utils.getErro(err)
      });
      return;
    }

    this.carregando = true;
    
    this.solicitacaoService.gerarItens(this.solicitacaoModel).pipe(finalize(() => this.carregando = false)).subscribe({
      next: (itens) => {
        if (!itens || itens.length === 0) {
          this.utils.handleWarning('Nenhum item encontrado para esta solicitação.');
          return;
        }

        this.solicitacaoModel.Itens = itens;

        // Definir datas padrão para facilitar preenchimento na tela (removível futuramente)
        const dataMin = new Date();
        const dataMax = new Date();
        dataMax.setDate(dataMin.getDate() + 30);

        this.solicitacaoModel.Itens.forEach(item => {
          item.DataMinimoEntrega = dataMin;
          item.DataMaximoEntrega = dataMax;
        });

        this.agruparItens(itens);
        this.step = 2;
      },
      error: (err) => this.utils.getErro(err)
    });
  }

  adicionarInsumo() {
    const novoItem = new ItensSolicitacaoComprasDTO();
    
    // Datas padrão: hoje e hoje + 30 dias
    const dataMin = new Date();
    const dataMax = new Date();
    dataMax.setDate(dataMin.getDate() + 30);
    
    novoItem.DataMinimoEntrega = dataMin;
    novoItem.DataMaximoEntrega = dataMax;
    novoItem.AreaTotal = this.areaTotalPlanejada;
    novoItem.GrupoProdutoId = null;
    
    if (!this.solicitacaoModel.Itens) {
      this.solicitacaoModel.Itens = [];
    }
    
    this.solicitacaoModel.Itens.push(novoItem);
    this.agruparItens(this.solicitacaoModel.Itens);
  }

  onGrupoChange(grupoId: number, item: ItensSolicitacaoComprasDTO) {
    this.currentGrupoId = grupoId || 0;
    item.ProdutoId = null;
    item.ProdutoDescricao = '';
    item.UnidadeMedida = '';
    item.PrincipioAtivo = '';
    item.PrecoUnitarioMedio = 0;
    this.calcularTotais(item);
    
    const grupo = this.gruposProdutos.find(g => g.Id === grupoId);
    item.DescricaoGrupoProduto = grupo ? grupo.Descricao : 'Outros';
    
    this.pagina = 1;
    this.produtosPaginados = [];
    this.ultimaPagina = false;
    this.fetchMoreProdutos('', this.currentGrupoId, true);
  }

  onFocusProduto(item: ItensSolicitacaoComprasDTO) {
    if (this.currentGrupoId !== item.GrupoProdutoId) {
       this.currentGrupoId = item.GrupoProdutoId || 0;
       // Se mudar de grupo, reseta e busca
       this.pagina = 1;
       this.produtosPaginados = [];
       this.ultimaPagina = false;
       this.fetchMoreProdutos('', this.currentGrupoId, true);
    } else if (this.produtosPaginados.length === 0 && item.GrupoProdutoId) {
       // Se o grupo for o mesmo mas a lista estiver vazia (ex: acabamos de abrir o modal)
       this.fetchMoreProdutos('', this.currentGrupoId, true);
    }
  }

  carregarProdutosExistentes() {
    if (!this.solicitacaoModel.Itens || this.solicitacaoModel.Itens.length === 0) return;
    
    const uniqueIds = [...new Set(this.solicitacaoModel.Itens.map(i => i.ProdutoId).filter(id => !!id))];
    uniqueIds.forEach(id => {
      this.produtoService.getProduto(id).subscribe(prod => {
        if (prod && !this.produtosPaginados.find(p => p.Id === prod.Id)) {
          this.produtosPaginados.push(prod);
          // Preserve the list if we were in the middle of something? 
          // Actually abrindo modal resets things, so this is safe.
        }
      });
    });
  }

  changeProduto(produtoId: number, item: ItensSolicitacaoComprasDTO) {
    if (!produtoId) return;
    
    const produto = this.produtosPaginados.find(p => p.Id === produtoId);
    if (produto) {
      item.ProdutoDescricao = produto.Descricao;
      item.UnidadeMedida = produto.UnidadeMedida;
      item.PrincipioAtivo = produto.PrincipioAtivo;
      item.PrecoUnitarioMedio = produto.PrecoUnitario || 0;
      this.calcularTotais(item);
    } else {
      // Se não achar na lista atual (por paginação), busca detalhes
      this.produtoService.getProduto(produtoId).subscribe(res => {
        item.ProdutoDescricao = res.Descricao;
        item.UnidadeMedida = res.UnidadeMedida;
        item.PrincipioAtivo = res.PrincipioAtivo;
        item.PrecoUnitarioMedio = res.PrecoUnitario || 0;
        this.calcularTotais(item);
        
        // Adiciona à lista para garantir que o bindLabel funcione
        if (!this.produtosPaginados.find(p => p.Id === res.Id)) {
          this.produtosPaginados.push(res);
        }
      });
    }
  }

  calcularTotais(item: ItensSolicitacaoComprasDTO) {
    item.QuantidadeTotal = (item.Dose || 0) * (item.AreaTotal || 0);
    item.ValorTotal = (item.QuantidadeTotal || 0) * (item.PrecoUnitarioMedio || 0);
    item.ValorMedioHa = item.AreaTotal > 0 ? (item.ValorTotal / item.AreaTotal) : 0;
  }

  timerFetch: any;
  fetchMoreProdutos(termo ?: string, grupoId ?: number, immediate: boolean = false) {
    if (this.timerFetch) clearTimeout(this.timerFetch);

    const execute = () => {
      // Padrão TabelaInsumos: termo null significa manter a busca atual (paginação)
      // termo como string significa nova busca (reset)
      if (termo !== null && termo !== undefined) {
          this.termoBusca = termo;
          this.pagina = 1;
          this.ultimaPagina = false;
      }

      const gId = grupoId !== undefined ? grupoId : this.currentGrupoId;
      
      this.carregandoProduto = true;
      
      this.produtoService.getTodosProdutosPaginando(this.pagina, 20, gId, this.termoBusca).subscribe({
        next: (ret) => {
          this.carregandoProduto = false;
          
          if (!ret || !ret.Lista) {
            return;
          }

          if (termo !== null && termo !== undefined) {
             // Nova busca: limpa lista mas mantém selecionados para não quebrar label
             const selectedIds = this.solicitacaoModel.Itens.map(i => i.ProdutoId).filter(id => !!id);
             const currentSelectedObjects = this.produtosPaginados.filter(p => selectedIds.includes(p.Id));
             
             const newIds = ret.Lista.map(p => p.Id);
             const itemsToKeep = currentSelectedObjects.filter(p => !newIds.includes(p.Id));
             
             this.produtosPaginados = [...ret.Lista, ...itemsToKeep];
          } else {
             // Paginação: concatena
             const ids = this.produtosPaginados.map(p => p.Id);
             const novos = ret.Lista.filter(p => !ids.includes(p.Id));
             this.produtosPaginados = [...this.produtosPaginados, ...novos];
          }
         
          this.ultimaPagina = ret.TotalPaginas <= this.pagina;
          if (!this.ultimaPagina) {
            this.pagina++;
          }
        },
        error: (err) => {
          this.carregandoProduto = false;
          this.utils.getErro(err);
        }
      });
    };

    if (immediate) {
      execute();
    } else {
      this.timerFetch = setTimeout(execute, 400);
    }
  }

  onScrollToEndProduto() {
    if (this.carregandoProduto || this.ultimaPagina) return;
    this.fetchMoreProdutos(null, this.currentGrupoId);
  }

  agruparItens(itens: any[]) {
    const groups = itens.reduce((acc, current) => {
      const grupo = current.DescricaoGrupoProduto || 'Outros';
      if (!acc[grupo]) {
        acc[grupo] = {
          nome: grupo,
          collapsed: false,
          itens: []
        };
      }
      acc[grupo].itens.push(current);
      return acc;
    }, {});

    this.groupedItems = Object.keys(groups).map(key => groups[key]);
  }

  voltar(): void {
    this.step = 1;
  }

  save(): void {
    
    this.solicitacaoModel.AnoSafraIds = [this.solicitacaoModel.AnoSafraId];
    this.carregando = true;
    const request = this.solicitacaoId > 0 
      ? this.solicitacaoService.putSolicitacao(this.solicitacaoId, this.solicitacaoModel)
      : this.solicitacaoService.postSolicitacao(this.solicitacaoModel);

    request.pipe(finalize(() => this.carregando = false)).subscribe({
      next: () => {
        this.utils.handleSuccess('Solicitação salva com sucesso!');
        this.finalizarSave.emit();
        this.fecharModal();
      },
      error: (err) => {
        this.utils.getErro(err);
      }
    });
  }

  onCampoFiltroChange() {
    if (this.isPlanejada) return;
    this.solicitacaoModel.PlanejamentoIds  = [];
    this.carregarTalhoes();
  }

  carregarTalhoes() {
    if (this.isPlanejada || !this.solicitacaoModel.AnoSafraId) {
      this.listPlanejamentos = [];
      return;
    }

    const filtro = new PlanejamentoFiltroDto();
    filtro.AnoSafraIds = [this.solicitacaoModel.AnoSafraId];
    filtro.FazendaIds = this.solicitacaoModel.FazendaIds || [];
    filtro.CulturaIds = this.solicitacaoModel.CulturaIds || [];

    this.planejamentoService.buscarByStatus(filtro).subscribe({
      next: (ret) => {
        // Mapear planejamento para o formato do select (DescricaoArea costuma ser o talhão no Planejamento)
        this.listPlanejamentos = ret.map(p => ({
          Id: p.Id,
          Descricao: p.DescricaoArea || p.Descricao
        }));
      },
      error: (err) => this.utils.getErro(err)
    });
  }

  getFazendaNomes(): string {
    if (!this.solicitacaoModel.FazendaIds || this.solicitacaoModel.FazendaIds.length === 0) return '-';
    return this.fazendas
      .filter(f => this.solicitacaoModel.FazendaIds.includes(f.Id))
      .map(f => f.Nome)
      .join(', ') || '-';
  }

  getSafraNome(): string {
    if (!this.solicitacaoModel.AnoSafraId) return '-';
    const safra = this.anosSafras.find(s => s.Id === this.solicitacaoModel.AnoSafraId);
    return safra ? safra.Descricao : '-';
  }

  private parseIds(value: any): number[] {
    if (!value) return [];
    
    // If it's already an array
    if (Array.isArray(value)) {
      return value.map(id => Number(id)).filter(id => !isNaN(id) && id !== 0);
    }
    
    // If it's a number
    if (typeof value === 'number') {
      return [value];
    }
    
    // If it's a string (comma-separated or single)
    if (typeof value === 'string') {
      return value.split(',')
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id) && id !== 0);
    }
    
    return [];
  }
}
